import * as tslib_1 from "tslib";
import { Component, Prop, Emit } from 'vue-property-decorator';
import { ComponentBase } from './ComponentBase';
import Gallery from './Gallery.vue';
var ImageList = /** @class */ (function (_super) {
    tslib_1.__extends(ImageList, _super);
    function ImageList() {
        return _super.call(this) || this;
    }
    Object.defineProperty(ImageList.prototype, "thisFiles", {
        get: function () {
            return this.files;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageList.prototype, "thisReadonly", {
        get: function () {
            return this.readonly;
        },
        enumerable: true,
        configurable: true
    });
    ImageList.prototype.onDelete = function (file) { };
    ImageList.prototype.show = function (file) {
        this.$refs.gallery.show(file.remoteUrl, file);
    };
    ImageList.prototype.handlerDelete = function (data) {
        this.onDelete(data);
    };
    tslib_1.__decorate([
        Prop({ type: [Array], default: function () { return []; } })
    ], ImageList.prototype, "files", void 0);
    tslib_1.__decorate([
        Prop({ type: [Boolean], default: function () { return true; } })
    ], ImageList.prototype, "readonly", void 0);
    tslib_1.__decorate([
        Emit()
    ], ImageList.prototype, "onDelete", null);
    ImageList = tslib_1.__decorate([
        Component({
            components: {
                Gallery: Gallery,
            }
        })
    ], ImageList);
    return ImageList;
}(ComponentBase));
export default ImageList;
